// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var traverseWithIndex_ = /* #__PURE__ */ Data_FoldableWithIndex.traverseWithIndex_(Specular_Dom_Builder.applicativeBuilder)(Data_FoldableWithIndex.foldableWithIndexArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var onDomEvent = /* #__PURE__ */ Specular_Dom_Builder_Class.onDomEvent(monadFRP);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Data_Maybe.bindMaybe);
var unsafeIndex = /* #__PURE__ */ Data_Array.unsafeIndex();
var holdDyn = /* #__PURE__ */ Specular_FRP_Base.holdDyn(monadFRP);
var selectInput = function (dictMonadWidget) {
    var liftWidget = Specular_Dom_Widget.liftWidget(dictMonadWidget.MonadDomBuilder0());
    return function (config) {
        return liftWidget((function () {
            var toOption = function (index) {
                return function (value) {
                    return Specular_Dom_Element.el("option")([ attr("value")(show(index)) ])(Specular_Dom_Element.text(config.display(value)));
                };
            };
            return bind(Specular_Dom_Element["el$prime"]("select")([ Specular_Dom_Element.attrsD(config.attributes) ])(traverseWithIndex_(toOption)(config.options)))(function (v) {
                return discard(liftEffect(Specular_Dom_Browser.setTextInputValue(v.value0)(show(config.initialValueIndex))))(function () {
                    return bind(newEvent)(function (domChanged) {
                        return discard(onDomEvent("change")(v.value0)(function (v1) {
                            return bind1(Specular_Dom_Browser.getTextInputValue(v.value0))(domChanged.fire);
                        }))(function () {
                            var valueChanged = Specular_FRP_Base.filterMapEvent(composeKleisli(Data_Int.fromString)(Data_Array.index(config.options)))(domChanged.event);
                            var initialValue = unsafeIndex(config.options)(config.initialValueIndex);
                            return holdDyn(initialValue)(valueChanged);
                        });
                    });
                });
            });
        })());
    };
};
export {
    selectInput
};
